var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyframeMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 181,
    viewBox: "0 0 12 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5008 181V15.4317L0 11.1078V0H11.9997V11.1078L6.5007 15.4465V181H5.5008Z",
    fill: "#203662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyframeMarker);
export default __webpack_public_path__ + "static/media/keyframeMarker.96130e60ff67b328b4e66e535bb06b34.svg";
export { ForwardRef as ReactComponent };